var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"main-nav main-nav--footer"},_vm._l((_vm.menu),function(item,index){return _c('li',{staticClass:"main-nav__item"},[_c('a',{staticClass:"main-nav__link main-nav__link--footer",attrs:{"href":'/' + item.link}},[_vm._v("\n            "+_vm._s(item.title)+"\n        ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }